export const ROLES = {
  EMPLOYEE: "employee",
  ADMIN: "admin",
  SUPER_USER: "superuser",
}

export default ROLES
